import Cookies from 'js-cookie'
import { meetingsearch } from '@/api/seedetails'
import { getDepartTree } from '@/api/user'

const app = {
  state: {
    sidebar: {
      opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
      withoutAnimation: false
    },
    device: 'desktop',
    language: Cookies.get('language') || 'zh',
    size: Cookies.get('size') || 'medium',
    meetingRun: [],
    showTip: false,
    meetingList: [],
    departTree: []
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 0)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    SET_SIZE: (state, size) => {
      state.size = size
      Cookies.set('size', size)
    },
    CHANGE_TIP: (state) => {
      state.showTip = true
    },
    CLOSE_TIP: (state) => {
      state.showTip = false
    },
    SAVE_MEETINGS: (state, list) => {
      state.meetingList = list
    },
    SAVE_DEPARTTREE: (state, list) => {
      state.departTree = list.sort((a, b) => {
        return a.udSort - b.udSort
      })
    }
  },
  actions: {
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setSize({ commit }, size) {
      commit('SET_SIZE', size)
    },
    showTip({ commit }) {
      commit('CHANGE_TIP')
    },
    closeTip({ commit }) {
      commit('CLOSE_TIP')
    },
    getMeetingRun({ commit }) {
      const now = new Date()
      now.setTime(now.getTime())
      const Y = now.getFullYear()
      const M = (now.getMonth() + 1) < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1
      const D = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
      const today = Y + '-' + M + '-' + D
      const form = {
        estimate_start_time: today + ' ' + '00:00:00',
        estimate_end_time: today + ' ' + '23:59:59',
        own_meeting: 1,
        meeting_status: [1]
      }
      let meetingList = []
      const p1 = new Promise((resolve, reject) => {
        meetingsearch(form).then(res => {
          if (res.data) {
            meetingList = meetingList.concat(res.data.meetings)
          } else {
            // this.meetingList = []
          }
          resolve()
        }).catch(() => {
          reject()
        })
      })
      const p2 = new Promise((resolve, reject) => {
        const obj = JSON.parse(JSON.stringify(form))
        obj.type_id = 7
        obj.own_meeting = 1
        meetingsearch(obj).then(res => {
          if (res.data) {
            meetingList = meetingList.concat(res.data.meetings)
          } else {
            // this.meetingList = [];
          }
          resolve()
        }).catch(() => {
          reject()
        })
      })
      // commit('CLOSE_TIP')
      Promise.all([p1, p2]).then(res => {
        console.log('请求已接受')
        commit('SAVE_MEETINGS', meetingList)
        if (meetingList.length > 0) {
          commit('CHANGE_TIP')
        }
      }).catch(err => {
        console.log(err)
      })
    },
    async getDepartData({ commit }) {
      return new Promise((resolve, reject) => {
        getDepartTree().then(res => {
          commit('SAVE_DEPARTTREE', res.data)
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}

export default app
